import { useScopedOrders } from './useScopedOrders';

export function useBookingCalendarOrders() {
  const { orders, loading, error, refetch } = useScopedOrders({
    first: 100,
    paginateAll: true,
  });

  return {
    orders,
    loading,
    error,
    refetch,
  };
}
